export type ShiftIdentity = {
    readonly externalShiftId: string;
    readonly wellskyShiftUniqueId?: string | null;
};

export function buildShiftIdentityKey(shift: ShiftIdentity): string;
export function buildShiftIdentityKey(
    externalShiftId: string,
    wellskyShiftUniqueId?: string | null,
): string;
export function buildShiftIdentityKey(
    shiftOrExternalShiftId: ShiftIdentity | string,
    wellskyShiftUniqueId?: string | null,
): string {
    const externalShiftId =
        typeof shiftOrExternalShiftId === 'string'
            ? shiftOrExternalShiftId
            : shiftOrExternalShiftId.externalShiftId;
    const uniqueId =
        typeof shiftOrExternalShiftId === 'string'
            ? wellskyShiftUniqueId
            : shiftOrExternalShiftId.wellskyShiftUniqueId;

    return uniqueId ? `${externalShiftId}::${uniqueId}` : externalShiftId;
}
